<template>
  <div class="photo-gallery-container">
    <pt-modal
      ref="photoModal"
      close-button-position-in-header="right"
      transparent
    >
      <div slot="modal-header">Prescription</div>
      <div
        slot="modal-body"
        class="max-h-screen"
        @keydown.left="previous"
        @keydown.right="next"
      >
        <div v-if="selectedImage" class="photo-gallery-image-container">
          <img :src="selectedImage.image_medium_presigned" :alt="selectedImage.id" />
          <div class="photo-gallery-image-title">{{ selectedImage.id }}</div>
        </div>
        <button
          v-show="selectedIndex > 0"
          type="button"
          class="photo-gallery-navigator photo-gallery-navigator__previous"
          autofocus
          @click="previous"
        >
          <i class="fa fa-chevron-left" />
        </button>
        <button
          v-show="selectedIndex < total - 1"
          type="button"
          class="photo-gallery-navigator photo-gallery-navigator__next"
          autofocus
          @click="next"
        >
          <i class="fa fa-chevron-right" />
        </button>
      </div>
    </pt-modal>
  </div>
</template>

<script>
import { PtModal } from '@pathao/ui-components/esm/Modal';

export default {
  name: 'PtPhotoGallery',
  components: { PtModal },
  props: {
    title: {
      type: String,
      default() {
        return 'Photo Gallery';
      },
    },
    images: {
      type: Array,
      default() {
        return [];
      },
    },
    index: {
      type: Number,
      default() {
        return 0;
      },
    },
  },
  data() {
    return {
      selectedIndex: this.index,
      total: 0,
    };
  },
  computed: {
    selectedImage() {
      return this.images[this.selectedIndex];
    },
  },
  created() {
    this.total = this.images.length;
  },
  methods: {
    show() {
      this.$refs.photoModal.showModal();
    },
    previous() {
      if (this.selectedIndex > 0) {
        this.selectedIndex -= 1;
      }
    },
    next() {
      if (this.selectedIndex < this.total) {
        this.selectedIndex += 1;
      }
    },
    setIndex(index) {
      this.selectedIndex = index;
    },
  },
};
</script>
<style>
button.photo-gallery-navigator {
  font-size: 40px;
  color: white;
}
.photo-gallery-container .pt-modal-wrapper .pt-modal-header .pt-header-close-icon {
  font-size: 30px;
  color: white;
}
.photo-gallery-container .pt-modal-wrapper .pt-modal-header {
  font-size: 20px;
  color: white;
}
</style>
